import { FaiTabsEnum } from '@app-types/home-fai';

import { PlanTypeId } from '@constants/plan';

export const CATEGORY_MAPPING: Record<FaiTabsEnum, PlanTypeId> = {
    [FaiTabsEnum.PURE_BYOU]: PlanTypeId.FAI_ONGLET_BYOU,
    [FaiTabsEnum.BOX_INTERNET]: PlanTypeId.FAI_ONGLET_BBOX,
    [FaiTabsEnum.BOX_5G]: PlanTypeId.FAI_ONGLET_XGBOX,
    [FaiTabsEnum.FIN_DE_SERIE]: PlanTypeId.FAI_ONGLET_FIN_DE_SERIE,
    [FaiTabsEnum.BIG]: PlanTypeId.FAI_ONGLET_BBOX,
};
